import classNames from 'classnames';
import { StylishNewCheckbox } from 'components/DesignSystems/New/StylishNewCheckbox';
import React from 'react';
import { useFormContext } from 'react-hook-form';

type FormCheckboxFieldProps = {
  title: string;
  fieldName: string;
  rules?: { [key: string]: { value: any; message: string } };
  variant?: 'full' | 'half';
  disabled?: boolean;
};

const FormCheckboxField: React.FC<FormCheckboxFieldProps> = ({
  title,
  fieldName,
  rules,
  variant = 'full',
  disabled = false,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const required = typeof rules?.required === 'object';

  return (
    <div
      className={classNames('mt-2', {
        'col-6': variant === 'half',
        'col-12': variant === 'full',
      })}
    >
      <StylishNewCheckbox
        label={title}
        required={required}
        disabled={disabled}
        {...register(fieldName, rules)}
      />
      {/** TODO: check that the error state looks reasonable. */}
      {errors[fieldName] ? (
        <div className="form-text form-error">
          {errors[fieldName].message as string}
        </div>
      ) : (
        <div className="form-text-none"></div>
      )}
    </div>
  );
};
export default FormCheckboxField;
